import React, { PureComponent } from 'react';
import styled from 'styled-components';

import { media } from '~/styles/Utils';
import { trackEvent } from '~/Utils';

import EmbedIcon from '../Assets/embed.svg';
import InfoIcon from '../Assets/info.svg';
import ShareIcon from '../Assets/share.svg';
import TwitterIcon from '../Assets/twitter.svg';
import FacebookIcon from '../Assets/facebook.svg';

import { getHrefFb, getHrefTw } from './ShareUtils';

const SharingWrapper = styled.div`
  display: flex;

  ${media.m`
    justify-content: flex-end;
  `}
`;

const SharingButton = styled.div`
  color: ${props => props.theme.colors.greyblue};
  text-transform: uppercase;
  font-size: 12px;
  margin-right: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  position: relative;

  &:hover {
    color: ${props => props.theme.colors.darkblue};
    fill: ${props => props.theme.colors.darkblue};
  }
`;

const ShareButton = styled(SharingButton)`
  &:hover {
    .ShareButtons {
      display: flex;
    }
  }
`;

const ShareButtons = styled.div`
  display: none;
  height: 20px;
  width: 100px;
  flex-wrap: wrap;
  position: absolute;
  top: 10px;
`;

const SharingButtonLabel = styled.div`
  margin-left: 4px;
`;

const SharingLink = styled.a.attrs({
  target: '_blank'
})`
  padding: 3px;

  &:hover {
    opacity: .9;
  }
`;

class Sharing extends PureComponent {
  render() {
    const onInfoClick = () => {
      this.props.setInfoboxContent('faq');
      trackEvent('info_click');
    };

    const onEmbedClick = () => {
      this.props.setInfoboxContent('embed');
      trackEvent('embed_click');
    };

    return (
      <SharingWrapper>
        <SharingButton onClick={onInfoClick}>
          <InfoIcon width={10} height={11} />
          <SharingButtonLabel>Info</SharingButtonLabel>
        </SharingButton>
        <ShareButton>
          <ShareIcon width={10} height={11} />
          <SharingButtonLabel>Teilen</SharingButtonLabel>
          <ShareButtons className="ShareButtons">
            <SharingLink href={getHrefTw()}><TwitterIcon style={{ fill: '#1da1f2' }} width={18} /></SharingLink>
            <SharingLink href={getHrefFb()}><FacebookIcon style={{ fill: '#3b5998' }} width={18} /></SharingLink>
          </ShareButtons>
        </ShareButton>
        <SharingButton onClick={onEmbedClick}>
          <EmbedIcon width={10} height={11} />
          <SharingButtonLabel>Einbetten</SharingButtonLabel>
        </SharingButton>
      </SharingWrapper>
    );
  }
}

export default Sharing;
